export default function CTASection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row gap-0 max-w-6xl mx-auto rounded-lg overflow-hidden bg-background-50">
          <div className="lg:w-[55%] relative min-h-[320px] md:min-h-[400px] overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20curated%20product%20display%20featuring%20premium%20leather%20tote%20bag%2C%20designer%20sneakers%20and%20minimalist%20watch%20on%20marble%20surface%2C%20warm%20natural%20light%20streaming%20from%20left%2C%20luxury%20retail%20editorial%20aesthetic%2C%20champagne%20and%20cream%20tones%2C%20sophisticated%20lifestyle%20composition&width=1000&height=700&seq=cta-v2-product-showcase&orientation=landscape"
              alt="Hipobuy Spreadsheet curated shopping resources"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute top-5 left-5">
              <span className="text-xs font-label text-white/70 uppercase tracking-wider">Curated For You</span>
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
              <h3 className="text-xl md:text-2xl lg:text-3xl font-heading font-bold text-white leading-tight">
                Ready to<br />Transform Your<br />Shopping Research?
              </h3>
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
          </div>

          <div className="lg:w-[45%] flex flex-col items-center justify-center p-8 md:p-12 text-center">
            <h3 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 leading-tight mb-4">
              Explore the Complete<br />Hipobuy Spreadsheet Database
            </h3>
            <p className="text-sm md:text-base font-body text-foreground-600 leading-relaxed mb-8 max-w-sm">
              Thousands of organized product resources across fourteen categories. Updated weekly with fresh discoveries — start exploring the most comprehensive shopping spreadsheet hub available.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="cta-button inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-white text-sm md:text-base font-label font-semibold rounded-full hover:bg-primary-600 transition-colors"
            >
              Visit Hipobuy Sheet Now
              <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}